import { Mui } from "@osu/react-ui";

function LoadingSpinner({isFetching, count = 3, height = "default", margin = "", width = "default"}) {
    if (!isFetching) { return <></>; }
    
    return [...Array(count)].map((_, index) => <Mui.Skeleton key={`skele#${index}`} height={height} sx={{ margin }} width={width} />);
}

export default LoadingSpinner;